export default {
  'meta': {
    'langName': 'INDONESIA',
    'lang': 'Indonesia'
  },
  'title': 'PENARIKAN PRODUK BASKETBALL HOOP B900 BOX NBA TARMAK',
  'description': 'Kami telah mengidentifikasi risiko tiang jatuh pada ring basket B900 jika digunakan tanpa tuas pengatur ketinggiannya dan dimanipulasi.\nDemi keselamatan Anda, segera hentikan semua penggunaan jika produk tidak dipasangi tuas pengatur ketinggian.\nProduk Anda dapat diamankan melalui prosedur sederhana dengan menggunakan kit perbaikan yang akan kami kirimkan secara gratis.\nSitus web khusus untuk penarikan produk ini sedang dalam tahap pembangunan. Situs ini akan memandu Anda melalui langkah-langkah perbaikan yang diperlukan.\nKami akan segera memberi tahu Anda begitu situs tersebut tersedia (diperkirakan selama bulan Juli).',
  'status': 'Translation validated by COUNTRY'
} as const
